import { render, staticRenderFns } from "./CustomLogo.vue?vue&type=template&id=d3788b2a&"
import script from "./CustomLogo.vue?vue&type=script&lang=ts&"
export * from "./CustomLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports